import Helper from '@ember/component/helper';
import { format } from 'd3-format';
import { isNone } from '@ember/utils';

const DEFAULT_MAX_CHARS = 5;

export function shortenNumber([number], { maxChars = DEFAULT_MAX_CHARS } = {}) {
  if (isNaN(number)) {
    return '--';
  }

  if (isNone(maxChars)) {
    maxChars = DEFAULT_MAX_CHARS;
  }

  let comma = format(',');
  let prefix = format(`.${maxChars - 2}s`);
  let formatted = comma(number);
  let isLonger = formatted.length >= maxChars;

  if (isLonger) {
    return prefix(number);
  }

  return formatted;
}

/*
  Basic Usage:

  ```handlebars
  {{shorten-number number maxChars=10}}
  ```
*/
export default Helper.helper(shortenNumber);
